import { FC, useEffect } from "react";
import { NavigateOptions, useNavigate } from "react-router-dom";
import { Loader } from "shared/components/Loader";

export const Redirect: FC<{ href: string; options?: NavigateOptions }> = ({
  href,
  options
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (href) navigate(href, options);
  }, [href]);

  return (
    <div className="flex w-full justify-center animate-appear mx-auto max-w-md items-center p-10">
      <Loader className="my-4" />
    </div>
  );
};
